import type { QueryClient } from '@tanstack/react-query'
import { trpc } from '@/lib/trpc'

/** Refresh the shared policy state projections, including every cached input variant. */
export async function invalidatePolicyQueries(queryClient: QueryClient): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: trpc.complianceProgram.getPolicies.queryKey() }),
    queryClient.invalidateQueries({ queryKey: trpc.complianceProgram.getGenerationItems.queryKey() }),
  ])
}
